export const callApi = async (method, endpoint, sitekey, data) => {
  const url = `${process.env.API}${endpoint}`;

  const token = localStorage.getItem("token");

  const headers = new Headers();

  headers.append("Content-Type", "application/json");
  headers.append("X-Instance", sitekey);
  headers.append("X-Token", token);
  headers.append("X-Format-Date", "ISO8601");

  const response = await fetch(url, {
    method,
    headers,
    body: data ? JSON.stringify(data) : null,
  });
  if (response.status >= 400) {
    const error = {
      message: response.statusText,
      code: response.status,
    };
    throw error;
  }
  try {
    const json = await response.json();
    return json;
  } catch (error) {
    return response;
  }
};


// WEBPACK FOOTER //
// ./src/services/api.js